const baseUrl = window.location.origin || window.location.protocol + '//' + window.location.host;

// Change this line to turn on/off the device event logging by setting it to true/false
const deviceEventLoggingEnabled = false;

const environment = {
    baseUrl,
    apiBase: `${baseUrl}/api/v3`,
    deviceEventLoggingEnabled
};

const env = { ...(window.__env || {}), ...environment };
export default env;
